// import { zodResolver } from '@hookform/resolvers/zod';
// import { useLogin } from 'features/auth/hooks/useLogin';
// import { loginSchema } from 'features/auth/schemas/login.schema';
// import { useForm } from 'react-hook-form';
// import { Link } from 'react-router-dom';
// import Icon from '../components/AppIcon';
// import Button from '../components/ui/Button';
// import Input from '../components/ui/Input';
// import Image from 'components/AppImage';

// const Login = () => {
//   const { mutate: login, isPending } = useLogin();

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     resolver: zodResolver(loginSchema),
//     mode: 'onChange',
//     defaultValues: {
//       email: '',
//       password: '',
//     },
//   });

//   const onSubmit = (data) => {
//     login(data);
//   };

//   return (
//     <div className='min-h-screen flex items-center justify-center bg-background px-4 bg-admin'>
//       <div className='max-w-md w-full space-y-8'>
//         {/* Header */}
//         <div className='text-center'>
//           <div className='admin-logo'>
//             <Image
//                 src='/assets/images/logo.svg'
//                 alt='Qkly Logo'                
//               />
//           </div>

//         </div>
//         <div className='form-content'>
//           <p className='mt-2 mt-2 text-center font-bold text-black'>Sign in to your account</p>
//           {/* Login Form */}
//           <form className='mt-8 space-y-6' onSubmit={handleSubmit(onSubmit)}>
//             <div className='space-y-4'>
//               {/* Email Field */}
//               <div>
//                 <label htmlFor='email' className='block text-sm font-medium text-foreground mb-1'>
//                   Email Address
//                 </label>
//                 <Input
//                   id='email'
//                   type='email'
//                   placeholder='Enter your email'
//                   disabled={isPending}
//                   {...register('email')}
//                 />
//                 {errors.email && <p className='mt-1 text-sm text-red-500'>{errors.email.message}</p>}
//               </div>

//               {/* Password Field */}
//               <div>
//                 <div className='flex items-center justify-between mb-1'>
//                   <label htmlFor='password' className='block text-sm font-medium text-foreground'>
//                     Password
//                   </label>
//                   <Link to='/forgot-password' className='text-sm text-primary hover:underline'>
//                     Forgot Password?
//                   </Link>
//                 </div>
//                 <Input
//                   id='password'
//                   type='password'
//                   placeholder='Enter your password'
//                   disabled={isPending}
//                   {...register('password')}
//                 />
//                 {errors.password && <p className='mt-1 text-sm text-red-500'>{errors.password.message}</p>}
//               </div>
//             </div>

//             {/* Submit Button */}
//             <Button type='submit' className='w-full' disabled={isPending}>
//               {isPending ? (
//                 <>
//                   <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2' />
//                   Signing in...
//                 </>
//               ) : (
//                 <>
//                   <Icon name='LogIn' size={16} className='mr-2' />
//                   Sign In
//                 </>
//               )}
//             </Button>
//           </form>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Login;


import { useState } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useLogin } from 'features/auth/hooks/useLogin';
import { loginSchema } from 'features/auth/schemas/login.schema';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import Image from 'components/AppImage';
import { Eye, EyeOff } from 'lucide-react';

const Login = () => {
  const { mutate: login, isPending } = useLogin();

  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(loginSchema),
    mode: 'onChange',
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const onSubmit = (data) => {
    login(data);
  };

  return (
    <div className='min-h-screen flex items-center justify-center bg-background px-4 bg-admin'>
      <div className='max-w-md w-full space-y-8'>
        {/* Header */}
        <div className='text-center'>
          <div className='admin-logo'>
            <Image
              src='/assets/images/logo.svg'
              alt='Qkly Logo'
            />
          </div>
        </div>

        <div className='form-content'>
          <p className='mt-2 text-center font-bold text-black'>
            Sign in to your account
          </p>

          {/* Login Form */}
          <form className='mt-8 space-y-6' onSubmit={handleSubmit(onSubmit)}>
            <div className='space-y-4'>
              
              {/* Email Field */}
              <div>
                <label htmlFor='email' className='block text-sm font-medium text-foreground mb-1'>
                  Email Address
                </label>
                <Input
                  id='email'
                  type='email'
                  placeholder='Enter your email'
                  disabled={isPending}
                  {...register('email')}
                />
                {errors.email && (
                  <p className='mt-1 text-sm text-red-500'>
                    {errors.email.message}
                  </p>
                )}
              </div>

              {/* Password Field */}
              <div>
                <div className='flex items-center justify-between mb-1'>
                  <label htmlFor='password' className='block text-sm font-medium text-foreground'>
                    Password
                  </label>
                  <Link to='/forgot-password' className='text-sm text-primary hover:underline'>
                    Forgot Password?
                  </Link>
                </div>

                <div className='relative'>
                  <Input
                    id='password'
                    type={showPassword ? 'text' : 'password'}
                    placeholder='Enter your password'
                    disabled={isPending}
                    {...register('password')}
                    className='pr-10'
                  />

                  <button
                    type='button'
                    onClick={() => setShowPassword((prev) => !prev)}
                    className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700'
                    tabIndex={-1}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>

                {errors.password && (
                  <p className='mt-1 text-sm text-red-500'>
                    {errors.password.message}
                  </p>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <Button type='submit' className='w-full' disabled={isPending}>
              {isPending ? (
                <>
                  <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2' />
                  Signing in...
                </>
              ) : (
                <>
                  <Icon name='LogIn' size={16} className='mr-2' />
                  Sign In
                </>
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;